export class Model {
    constructor(public MoID?, public MoN?, public CatID?, public CatN?, public BID?, public BN?) { }
}